import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const wrapperSelector = '.wrapper[data-show-only-on]';
	const wrapperElements = document.querySelectorAll(wrapperSelector);

	if (!wrapperElements.length) {
		return;
	}

	let os = 'windows';

	if (navigator.userAgent.indexOf('Android') != -1) {
		os = 'android';
	}

	if (navigator.userAgent.indexOf('iphone') != -1 || navigator.userAgent.indexOf('iPad') != -1) {
		os = 'ios';
	}

	if (navigator.userAgent.indexOf('Mac') != -1) {
		os = 'macos';
	}

	[...wrapperElements].forEach((item) => {
		const showOnlyOn = item?.dataset?.showOnlyOn ?? '';

		if (!showOnlyOn.includes(os)) {
			item.style.display = 'none';
		}
	});
});
